export default __webpack_public_path__ + "static/media/close.0e3c1d25.svg";